import React, { useEffect } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../helpers/AssetHelpers'

function AuthLayout() {
    useEffect(() => {
        const root = document.getElementById('root')
        if (root) {
            root.style.height = '100vh'
        }
        return () => {
            if (root) {
                root.style.height = 'auto'
            }
        }
    }, [])

    return (
        <div className="container-fluid g-0 vh-100 overflow-hidden">
            <div className="row g-0 h-100">
                {/* Left Column - Form Section */}
                <div className="col-12 col-lg-6 d-flex flex-column h-100 bg-light">
                    <div className="d-flex flex-column h-100 px-3 px-sm-4 px-md-5 py-4">
                       
                        {/* Main Content - Will grow to fill available space */}
                        <div className="flex-grow-1 d-flex flex-center flex-column align-items-center">
                            <div className="w-100 w-md-500px h-100 animate__animated animate__fadeIn">
                             {<Outlet/>}
                               
                            </div>
                        </div>

                        {/* Footer - Fixed at bottom */}
                        <div className="py-3 mt-auto">
                            <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center fw-semibold text-muted fs-sm">
                                <span className="mb-2 mb-sm-0">© {new Date().getFullYear()} Eyeconx</span>
                                <span className="d-none d-sm-block mx-2">|</span>
                                <Link to="/terms-and-conditions" className="px-2 text-decoration-none text-muted mb-2 mb-sm-0">
                                    Terms & Conditions
                                </Link>
                                <span className="d-none d-sm-block mx-2">|</span>
                                <Link to="/contact-us" className="px-2 text-decoration-none text-muted">
                                    Contact Us
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Column - Banner Section */}
                <div
                    className="col-lg-6 d-none d-lg-flex align-items-center justify-content-center p-10 position-relative"
                    style={{
                        background: `linear-gradient(rgba(13, 110, 253, 0.85), rgba(13, 110, 253, 0.9)), url(${toAbsoluteUrl('media/misc/auth-bg.png')})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                    {/* Decorative elements */}
                    <div className="position-absolute top-0 start-0 w-100 h-100 overflow-hidden">
                        <div className="position-absolute top-0 end-0 w-100 h-100 bg-primary opacity-10" style={{
                            clipPath: 'polygon(100% 0, 0% 100%, 100% 100%)'
                        }}></div>
                    </div>
                    
                    <div className="text-white text-center px-5 position-relative z-1">
                        
                        <h1 className='text-white fs-2qx fw-bolder text-center mb-4 animate__animated animate__fadeInDown'>
                            Welcome to Eyeconx!
                        </h1>
                        <p className="lead mb-5 animate__animated animate__fadeInUp">
                            Eyeconx enables your practice to effortlessly and instantly send reminders,
                            recalls, notifications and education to patients via e-mails, SMS and telephone.
                        </p>
                        
                        <div className="d-flex justify-content-center animate__animated animate__fadeInUp">
                            <div className="d-flex">
                                 <div className="mx-2">
                                        <div className="bg-white bg-opacity-25 rounded-circle p-2 d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                                           <i className="bi bi-calendar-event"></i>
                                        </div>
                                    </div>
                                <div className="mx-2">
                                        <div className="bg-white bg-opacity-25 rounded-circle p-2 d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                                           <i className="bi bi-arrow-repeat"></i>
                                        </div>
                                    </div>
                                <div className="mx-2">
                                        <div className="bg-white bg-opacity-25 rounded-circle p-2 d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                                           <i className="bi bi-bell"></i>
                                        </div>
                                    </div>
                                <div className="mx-2">
                                        <div className="bg-white bg-opacity-25 rounded-circle p-2 d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                                           <i className="bi bi-journal-text"></i>
                                        </div>
                                    </div>
                                <div className="mx-2">
                                        <div className="bg-white bg-opacity-25 rounded-circle p-2 d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                                           <i className="bi bi-chat-left"></i>
                                        </div>
                                    </div>
                                <div className="mx-2">
                                        <div className="bg-white bg-opacity-25 rounded-circle p-2 d-flex align-items-center justify-content-center" style={{width: '50px', height: '50px'}}>
                                           <i className="bi bi-telephone-forward"></i>
                                        </div>
                                    </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AuthLayout